import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";
import moment from "moment";
export class RFIItemResponseModel extends ModelBase<RFIItemResponseModel, RFIItemResponseModelDTO> {
    @MobX.observable
    public id: string = "";

    @MobX.observable
    public rfiId: string = "";

    @MobX.observable
    public comment: string = "";

    @MobX.observable
    public fromText: string = "";

    @MobX.observable
    public statusName: string = "";

    @MobX.observable
    public receivedDate: Date | null = null;

    @MobX.observable
    public createdDate: Date | null = null;

    @MobX.observable
    public createdByUserId: string = "";

    @MobX.observable
    public createdByName: string = "";

    @MobX.observable
    public lastUpdatedDate: Date | null = null;

    @MobX.observable
    public lastUpdatedByUserId: string = "";

    @MobX.observable
    public lastUpdatedByName: string = "";

    @MobX.observable
    public projectDirectoryPersonId: string | null = null;

    @MobX.observable
    public projectDirectoryPersonName: string | null = null;

    @MobX.observable
    public responseRequiredBy: string | null = null;

    @MobX.observable
    public isDeleted: boolean = false;

    @MobX.observable
    public reference: number | null = null;

    @MobX.computed
    public get receivedDateFormatted() {
        return this.receivedDate ? `${moment(this.receivedDate).format("DD/MM/YYYY")}` : "";
    }

    @MobX.computed
    public get createdDateFormatted() {
        return this.createdDate ? `${moment(this.createdDate).format("DD/MM/YYYY @ HH:mm")}` : "";
    }

    @MobX.computed
    public get lastUpdatedDateFormatted() {
        return this.lastUpdatedDate ? `${moment(this.lastUpdatedDate).format("DD/MM/YYYY @ HH:mm")}` : "";
    }

    @MobX.computed
    public get responseRequiredByFormatted() {
        return this.responseRequiredBy ? `${moment(this.responseRequiredBy).format("DD/MM/YYYY")}` : "";
    }

    fromDto(model: RFIItemResponseModelDTO): void {
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(model[key]);
                } else {
                    this[key] = model[key];
                }
            }
        }
    }

    toDto(model: RFIItemResponseModel): void {}
}

export type RFIItemResponseModelDTO = {
    id: string;
    rfiId: string;
    comment: string;
    receivedDate: Date | null;
    createdDate: Date | null;
    createdByUserId: string;
    createdByName: string;
    lastUpdatedDate: Date | null;
    lastUpdatedByUserId: string;
    lastUpdatedByName: string;
    projectDirectoryPersonId: string | null;
    projectDirectoryPersonName: string;
    responseRequiredBy: string | null;
    isDeleted: boolean;
    fromText: string;
    statusName: string;
    reference: number | null;
};
